module.exports = __webpack_public_path__ + "static/img/blancoT25_logo_zurqui.1535e009.png";